import * as React from 'react';
import MainCard from 'ui-component/cards/MainCard';
import SideMenu from './Components/LimitManagement/SideMenu';

const LimitLayout=()=>{
return(
    <MainCard  sx={{height:'80vh',overflowX:'scroll'}}>
        <SideMenu />
    </MainCard>
)
}

export default LimitLayout